import common from './common.vue';
import inputRange from './input-range.vue';
import customQueryComponent from './custom-query-component.vue';
import checkboxSchool from './checkbox-school.vue';

export default [
  common,
  inputRange,
  customQueryComponent,
  checkboxSchool,
];
